import { EMPTY_EQUIVALENT_PERMISSIONS } from '../constants';
const EMPTY_EQUIVALENT_PERMISSIONS_SET = new Set(EMPTY_EQUIVALENT_PERMISSIONS);
export const isEmptyPermissions = (permissions) => {
    const list = permissions ?? [];
    if (list.length === 0) {
        return true;
    }
    return list.every((permission) => EMPTY_EQUIVALENT_PERMISSIONS_SET.has(permission));
};
